import * as ActionTypes from '~/actions/ActionTypes'

export const setSearchValue = searchValue => async dispatch => {
  dispatch({
    type: ActionTypes.PROJECTS_SET_SEARCH_VALUE,
    payload: { searchValue },
  })
}
